import { EarningsInsightRecapResponse } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CitationsSection } from '../../../components/citations-section/CitationsSection';
import { DocumentsSection } from '../../../components/citations-section/documents-row/DocumentsSection';
import * as S from './DocumentsAndCitations.styles';

export interface DocumentsAndCitationsProps {
  earningsRecapData: EarningsInsightRecapResponse;
}

export const DocumentsAndCitations = ({
  earningsRecapData,
}: DocumentsAndCitationsProps) => {
  const { t } = useTranslation(['earnings']);

  return (
    <S.CitationsSectionWrapper>
      <S.CitationsTitle>
        {t('earningsInsight.drawer.citations')}
      </S.CitationsTitle>
      {!!earningsRecapData.documents.length && (
        <S.DocumentsWrapper>
          <DocumentsSection
            title={t('earningsInsight.drawer.documents')}
            count={earningsRecapData.documents.length}
            items={earningsRecapData.documents}
          />
        </S.DocumentsWrapper>
      )}
      {!!earningsRecapData.citations.length && (
        <CitationsSection
          title={t('earningsInsight.drawer.webLinks')}
          count={earningsRecapData.citations.length}
          items={earningsRecapData.citations}
        />
      )}
    </S.CitationsSectionWrapper>
  );
};
